// extracted by mini-css-extract-plugin
export default {"detailsContainer":"DetailOrderInformation_detailsContainer__g2VIl","appealLink":"DetailOrderInformation_appealLink__kHtgy"};